
<!-- Modal -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple">
<p class="loader-message">Loading...</p>
</ngx-spinner>
<ng-template #content let-modal >  
<div class="modal-header" style="background-color:dodgerblue;">
<h5 class="modal-title" style="color:white;">SmartView™ Chat</h5>
<button type="button" class="btn btn-default close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
<span aria-hidden="true">&times;</span></button>
</div>
<form #chatform="ngForm" class="form_class" >
<div class="modal-body">
<div class="=form-group">
<label for="topic">{{topic}}</label><span class="text-danger">*</span>
<div class="input-group mb-3">
  <input type="text" class="form-control" id="topic" [required]="true"
  [(ngModel)]=topicContent name="topicContent"/>
</div>
</div>
<div class="form-group" *ngIf="chatQueuesSize.length>=2">
    <label for="option1" id="option1" class="name">{{queueTest}}</label><span class="text-danger">*</span>
    <div class="queueTest">
      <select id="name" name="name"  class="form-control" [required]="true" [(ngModel)]="queues.external_name" #name="ngModel">
        <option [value]="title" [disabled]="chatform.valid" class="ng-binding">--Please Select--</option>
        <option *ngFor="let listQueue of listQueues" [value]="listQueue"  >{{listQueue}}</option>
      </select>
    </div>
</div><br>
<div [innerHTML]="plainText"></div>
</div>
<div class="modal-footer"> 
<button type="button" class="btn btn-warning"  (click)="close()" data-bs-dismiss="modal">{{i18n._value['shp.chat.cancel']}}</button>
<button type="button" id="chatStartBtn" [disabled]="!chatform.valid"  class="btn btn-primary"[hidden]="false" (click)=chatPopUp()>{{i18n._value['shp.chat.chat']}}</button>
</div>  
</form>  
</ng-template>
      
<!------------------------------------Smart CHat------------------------------------------------------>

<div id="smartChat" class="chatIcon"></div>
<div id="smartchatWindow" class="smartchatWindow popup-box" role="dialog" aria-describedby="smartchatWindowLabel" aria-labelledby="smartchatWindowLabel" aria-modal="true">
<div class="chatPopHeader">
  <span class="headerContent popup-head-left">Welcome</span>
  <button type="button" class="close closeChat text-muted btn btn" aria-label="close" (click)="close()" id="closeChat" style="color: #a9a9a9; float:right;right: 10px;top: 2.0px;">
    <span><i class="fa fa-close" style="font-size:16px"></i></span>
  </button>
</div>
<div  id="refreshContent" class="refreshContent" style="display:none"><i id="contentList" class="fc fc-spinner fc-spin fc-4x"></i></div>
<div class="chatContentBox">
  <div class="chatContent"></div></div>
  <div class="typeTip">
    <span class="typing_loader"></span>
  </div>
  <div class="panel-footer">
    <div class="input-group mb0">
      <input class="form-control noshade chatInput" placeholder= "Type Here..." type="text">
      <div class="input-group-btn">
        <button id="sendMsg" type="button" class="btn btn-send fa fa-mail-reply f15" title="Send Message"></button></div>
      </div>
    </div>
    <!-- <bgsound id="bg_sound"></bgsound> -->
    <div id="status" class="status_bar popup-bottom"></div>
  </div>
  <!-- <app-home></app-home> -->
    
<input type="hidden" id="onePage" value="<%- page %>" />
<input type="hidden" id="component" value="<%- component %>" />
<input type="hidden" id="is_authed" value="<%- is_authed %>" />
<input type="hidden" id="login_user_pk" value="<%- login_user_pk %>" />
<input type="hidden" id="shortname" value="<%- shortname %>" />
<input type="hidden" id="sChat" value="<%- svChatConfig.is_smart_view_chat %>" />
<input type="hidden" id="sChatText" value="<%- svChatConfig.queueSelectionText %>" />
<input type="hidden" id="schatTopicPrompt" value="<%- svChatConfig.chatTopicPrompt %>" />
<input type="hidden" id="schatPrivacy" value="<%- svChatConfig.privacy_type %>" />
<input type="hidden" id="auth" value="<%- config.chat %>" />
<div class="svButton" style="display:none"></div>
<div id="svchatplugin"></div>